import { Text as BaseText } from './Text';
import * as SemanticTextComponents from './SemanticTextComponents';

/**
 * Base text component. Before using this, please **make sure there's not already another Semantic text component that fits your needs.**
 * @example
 * // Basic text
 * <Text {...props}>Hello World</Text>
 * // Semantic text components
 * <Text.PageHeader>Hello World</Text.PageHeader>
 * <Text.SectionHeader>Hello World</Text.SectionHeader>
 * <Text.TabHeader>Hello World</Text.TabHeader>
 * <Text.CardHeader>Hello World</Text.CardHeader>
 * ...
 */
const Text = BaseText as typeof BaseText & typeof SemanticTextComponents;

Object.assign(Text, SemanticTextComponents);

export { Text };
